<template>
  <div class="notification-icon__wrapper" :class="dynamicWrapperClass">
    <a-lazy-hydrate when-visible>
      <div class="notification-icon__container" @click="onClick">
        <a-icon
          :id="$options.consts.ACTIVATOR_ID.HEADER_NOTIFICATIONS"
          :icon="$options.consts.ICON.BELL_WHITE"
          :width="18"
          :height="20"
          fill="#fff"
          no-hover
          original
          is-button
          aria-label="Notifications"
          :disabled="!isLoggedIn"
        />
      </div>
    </a-lazy-hydrate>
    <a-lazy-hydrate v-if="isCounterVisible" when-visible>
      <div class="notification-icon__notification-area" @click="onClick">
        <span class="notification-icon__notification-count">
          {{ notificationCountFormatted }}
        </span>
      </div>
    </a-lazy-hydrate>
  </div>
</template>

<script>
import AIcon, { ICON } from 'shared/AIcon/index.vue'
import { PROP_TYPES, propValidator } from '@fmpedia/validators'
import { mapGetters } from 'vuex'
import { ACTIVATOR_ID } from 'enums/activator-id'

const MAX_NOTIFICATION_COUNT_TO_DISPLAY = 999

export default {
  name: 'ANotificationIcon',
  components: { AIcon },
  props: {
    isActive: propValidator([PROP_TYPES.BOOLEAN], false, false),
    notificationCount: propValidator([PROP_TYPES.NUMBER], false, 0)
  },
  consts: {
    ICON,
    ACTIVATOR_ID
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'auth/isLoggedIn'
    }),
    dynamicWrapperClass() {
      return {
        active: this.isActive
      }
    },
    notificationCountFormatted() {
      return this.notificationCount > MAX_NOTIFICATION_COUNT_TO_DISPLAY
        ? `${MAX_NOTIFICATION_COUNT_TO_DISPLAY}+`
        : this.notificationCount
    },
    isCounterVisible() {
      return this.isLoggedIn && this.notificationCount > 0
    }
  },
  methods: {
    onClick() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
.notification-icon__wrapper {
  position: relative;
  cursor: pointer;
  border-radius: 50%;

  &.active {
    .notification-icon__container {
      background: $c--main;
    }
  }

  .notification-icon__container {
    border-radius: 100px;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: $c--gray-darkest-2;
  }

  /deep/ .a-icon {
    &.a-icon_disabled.a-icon_is-button {
      opacity: 1;
    }
  }

  .notification-icon__notification-area {
    position: absolute;
    top: -4px;
    right: -4px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 2px;
    padding-right: 2px;
    min-width: 18px;
    height: 18px;
    border-radius: 50%;
    overflow: hidden;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    background: $c--error;
  }

  .notification-icon__notification-count {
    font-size: 10px;
    font-weight: 600;
    line-height: 14px;
    color: $c--white;
  }
}
</style>
